import _extends from "@babel/runtime/helpers/esm/extends";
import { ECurrencyCode } from '../common';
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let ESource;
(function (ESource) {
  ESource["System"] = "system";
  ESource["Ehr"] = "ehr";
  ESource["Manual"] = "manual";
})(ESource || (ESource = {}));
export let EBillingCopayType;
(function (EBillingCopayType) {
  EBillingCopayType["Copay"] = "copay";
  EBillingCopayType["Dental"] = "dental";
  EBillingCopayType["Medical"] = "medical";
  EBillingCopayType["Behavioral"] = "behavioral";
  EBillingCopayType["Balance"] = "balance";
  EBillingCopayType["Custom"] = "custom";
})(EBillingCopayType || (EBillingCopayType = {}));
export let ELumaModel;
(function (ELumaModel) {
  ELumaModel["Appointments"] = "appointment";
  ELumaModel["Patients"] = "patient";
})(ELumaModel || (ELumaModel = {}));
export const fieldsBillingCopay = _extends({}, fieldsIBaseModel, {
  amount: {
    type: 'Number'
  },
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  calculation: {
    type: 'Text'
  },
  currency: {
    type: 'Option',
    values: ECurrencyCode
  },
  model: {
    type: 'Option',
    values: ELumaModel
  },
  name: {
    type: 'Text'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  preAuthorization: {
    type: 'Boolean'
  },
  source: {
    type: 'Option',
    values: ESource
  },
  type: {
    type: 'Option',
    values: EBillingCopayType
  },
  visible: {
    type: 'Boolean'
  }
});